import React from "react";
import "./filterBox.css";

// all css comes in FilterBox.css in PreReadFile  justify-content-between
// py-2 mt-2

const FilterBox = ({
  setChecked,
  checked,
  setFilter,
  filter,
  setClick1,
  setQuery,
}) => {
  const { sortChecked, timeChecked } = checked;
  const handleSortCheckboxChange = (e, index) => {
    setQuery([]);
    setChecked({ ...checked, sortChecked: index === sortChecked ? 1 : index });
    setFilter({ ...filter, page: 1, sortBy: e.target.value });
    setQuery([]);
  };

  const handleTimeCheckboxChange = (e, index) => {
    if (filter.time === e.target.value) {
      setQuery([]);
      setChecked({ ...checked, timeChecked: index === timeChecked ? 1 : index });
      setFilter({ ...filter, page: 1, time: null });
    }
    else if (e.target.value === "null" && filter.time === null) {
      setChecked({ ...checked, timeChecked: index === timeChecked ? 1 : index });
      setFilter({ ...filter, page: 1, time: null });
    }
    else {
      setChecked({ ...checked, timeChecked: index === timeChecked ? 1 : index });
      if (e.target.value === "null") {
        setQuery([]);
        setFilter({ ...filter, page: 1, time: null });
      } else {
        setQuery([]);
        setFilter({ ...filter, page: 1, time: e.target.value });
      }
    }
    console.log(filter);
  };
  return (
    <>
      <div className="p-2 filter_container">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="filter_heading">Filter</h4>
          <img
            src="/images/UpArrow.svg"
            alt=""
            style={{ cursor: "pointer" }}
            onClick={(e) => setClick1(false)}
          />
        </div>
        {/* gap-2 px-3   col-5    d-flex align-item-center flex-column subject_subbox */}
        {/* <div className="mx-2">
          <h5 className="mb-2 filter_first_heading">Date</h5>
          <div className="">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="1"
                id="flexCheckDefault"
                checked={1 === sortChecked}
                onChange={(e) => handleSortCheckboxChange(e, 1)}
              />
              <span>asce</span>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="-1"
                id="flexCheckDefault"
                checked={2 === sortChecked}
                onChange={(e) => handleSortCheckboxChange(e, 2)}
              />
              <span>desc</span>
            </div>
          </div>
        </div> */}
        <div className="mx-2">
          {/* <h5 className="mb-2 filter_first_heading">TIME</h5> */}
          <div>
            {/* <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="null"
                id="flexCheckDefault"
                checked={1 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 1)}
              />
              <span>All day</span>
            </div> */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="today"
                id="flexCheckDefault"
                checked={2 === timeChecked}
                onChange={(e) => {
                  handleTimeCheckboxChange(e, 2)
                  setClick1(false);
                }}
              />
              <span>Today</span>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="yesterday"
                id="flexCheckDefault"
                checked={3 === timeChecked}
                onChange={(e) => {
                  handleTimeCheckboxChange(e, 3)
                  setClick1(false);
                }}
              />
              <span>Yesterday</span>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="thisweek"
                id="flexCheckDefault"
                checked={4 === timeChecked}
                onChange={(e) => {
                  handleTimeCheckboxChange(e, 4)
                  setClick1(false);
                }}
              />
              <span>This Week</span>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value="thismonth"
                id="flexCheckDefault"
                checked={5 === timeChecked}
                onChange={(e) => {
                  handleTimeCheckboxChange(e, 5)
                  setClick1(false);
                }}
              />
              <span>This Month</span>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex">
        <button
          style={{
            width: "26px",
            height: "21px",
            color: "#F77F00",
            fontWeight: "600",
            fontSize: "10px",
            border: "none",
            background: "transparent",
            marginRight: "20px",
          }}
          onClick={() => {
            setClick1(false);
            setFilter((prevState) => ({ ...prevState, time: null }));
            setChecked({ ...checked, timeChecked: null });
          }}
        >
          Clear
        </button>
        {/* <button
          style={{
            width: "57px",
            height: "21px",
            borderRadius: "6px",
            backgroundColor: "#F77F00",
            color: "white",
            fontWeight: "600",
            fontSize: "10px",
            border: "none",
            background: "transparent",
            marginRight: "20px",
          }}
        >
          Apply
        </button> */}
      </div>
    </>
  );
};

export default FilterBox;
